import URLConfig from "@Config/urls/url.config";
import { LinkItemProps } from "@Layouts/sidebar/AppSidebar";

const URL = URLConfig.INTERFACE_MANAGEMENT.INTERFACE;

export const InterfaceSubMenuLink: Array<LinkItemProps> = [
  {
    name: "Gestion risque",
    link: URL.RISK_MANAGEMENT,
    level: 2,
  },
  {
    name: "Routage",
    link: URL.ROUTING,
    level: 2,
  },
  {
    name: "BIN",
    link: URL.BIN,
    level: 2,
  },
  {
    name: 'Autorisations',
    link: URL.AUTHORIZATIONS.ROOT,
    level: 2,
    subMenu: [
      {
        name: "Consultation des autorisations",
        link: URL.AUTHORIZATIONS.CONSULTING_AUTHORIZATIONS,
        level: 3,
      },
      {
        name: "Consultation SAF",
        link: URL.AUTHORIZATIONS.SAF_CONSULTATION,
        level: 3,
      },
    ]
  },
  {
    name: 'Interface',
    link: URL.INTERFACE.ROOT,
    level: 2,
    subMenu: [
      {
        name: "Mise à jour",
        link: URL.INTERFACE.UPDATE,
        level: 3,
      },
      {
        name: "HSM",
        link: URL.INTERFACE.HSM,
        level: 3,
      },
      {
        name: "Superviseur",
        link: URL.INTERFACE.SUPERVISOR,
        level: 3,
      },
    ]
  },
  {
    name: "Supervision",
    link: URL.SUPERVISION,
    level: 2,
  },
];

